// extracted by mini-css-extract-plugin
export default {"wraper":"Cookie_wraper__vtpO1","info":"Cookie_info__onSB0","text":"Cookie_text__pmCWS","link":"Cookie_link__nLyrA","cookieBtn":"Cookie_cookieBtn__rx9R6"};